/************************************** THIRD-PARTY MODULES ***************************************/
import Cookies from 'js-cookie';

/******************************************* CONSTANTS ********************************************/
/**
 * Fraction to convert day unit value to 30 minutes
 */
const in30Minutes = 1 / 48;

/********************************************* EXPORT *********************************************/
/**
 * Sets the cookie indicating that the user has logged in to given boolean
 * [value], and makes it last 30min
 */
export const setLoginCookie = (value: boolean) => {
    if (value) Cookies.set(`isLoggedIn`, `true`, {expires: in30Minutes});
    else Cookies.remove(`isLoggedIn`);
};
